import Messages from './Messages';
import MessagesPage from './MessagesPage';

export default {
    Messages,
    MessagesPage,
};